import { PortalViewErrorBoundary } from '@vs/component/portal-view-error-boundary';
import { withSentryReactRouterV6Routing } from '@vs/sentry-react-router-integration';
import { PortalBackdrop } from '@vs/ui/portal/backdrop';
import { Suspense, memo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { isLocalDevMode } from '../../constants';
import { getPathConfigs } from '../../constants/pathConfigs';
import { useAppSelector } from '../../redux/hooks';

function AppContentRoutes() {
  return (
    <PortalViewErrorBoundary enable={!isLocalDevMode}>
      <AppContentSentryRoutes />
    </PortalViewErrorBoundary>
  );
}

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

function AppContentSentryRoutes() {
  const location = useLocation();
  const selectedManagement = useAppSelector(s => s.global.selectedManagement);
  const managementPaths = getPathConfigs(selectedManagement, {
    flat: true,
    getAll: true,
  });
  const defaultFallbackPath = managementPaths?.find(p => !p.hide);

  return (
    <Suspense fallback={<PortalBackdrop open type="module_init" />}>
      <SentryRoutes>
        {managementPaths?.map(({ name, path, View }) => {
          if (!View) return null;
          return (
            <Route
              key={`/${selectedManagement}${path}${name}`}
              path={`/${selectedManagement}${path}`}
              element={<View />}
            />
          );
        })}
        {defaultFallbackPath !== undefined && (
          <Route
            path="*"
            element={
              <Navigate
                to={{
                  pathname: `/${selectedManagement}${defaultFallbackPath?.path}`,
                  search: location.search,
                }}
              />
            }
          />
        )}
      </SentryRoutes>
    </Suspense>
  );
}

export default memo(AppContentRoutes);
